import React from 'react';
import { Phone, MessageCircle, CheckCircle2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import BlobButton from '../components/BlobButton';

const SignupThankYou = () => {
  const navigate = useNavigate();

  const handleCallNow = () => {
    window.location.href = 'tel:+1 (866) 978-8498';
  };

  const handleChatNow = () => {
    // Trigger Zendesk chat
    if (window.zE) {
      window.zE('webWidget', 'open');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white flex items-center justify-center px-4 pt-20">
      <div className="max-w-2xl w-full text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-8">
          <div className="relative">
            <div className="absolute inset-0 bg-green-500 rounded-full blur-xl opacity-30 animate-pulse"></div>
            <div className="relative bg-green-500 rounded-full p-6">
              <CheckCircle2 className="w-16 h-16 text-white" />
            </div>
          </div>
        </div>

        {/* Main Message */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Thank You for Your Interest!
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-700 mb-8">
          We appreciate you reaching out to <span className="text-amber-700 font-semibold">Rushmore Publishing</span>
        </p>

        {/* Contact Message */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-amber-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900">What Happens Next?</h2>
          </div>
          
          <p className="text-lg text-gray-700 mb-6">
            Our publishing experts will review your submission and contact you <span className="font-bold text-amber-700">within the next 24 hours</span> to discuss your project in detail.
          </p>

          <div className="bg-amber-50 rounded-xl p-6 border-2 border-amber-200">
            <p className="text-gray-700 font-medium mb-2">In the meantime, if you have any urgent questions:</p>
            <p className="text-sm text-gray-600">Our team is standing by to assist you!</p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <BlobButton
            onClick={handleCallNow}
            className="flex items-center justify-center gap-2 min-w-[200px]"
          >
            <Phone className="w-5 h-5" />
            Call Now
          </BlobButton>
          
          <button
            onClick={handleChatNow}
            className="js-chat flex items-center justify-center gap-2 px-8 py-4 bg-white border-2 border-amber-700 text-amber-700 rounded-full font-bold hover:bg-amber-50 transition-all transform hover:scale-105 shadow-lg min-w-[200px]"
          >
            <MessageCircle className="w-5 h-5" />
            Chat Now
          </button>
        </div>

        {/* Back to Home */}
        <button
          onClick={() => navigate('/')}
          className="text-gray-600 hover:text-amber-700 transition-colors font-medium underline"
        >
          Return to Homepage
        </button>
      </div>
    </div>
  );
};

export default SignupThankYou;